var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-form',{ref:"seedlingsAndTransplant",model:{value:(_vm.validSubmission),callback:function ($$v) {_vm.validSubmission=$$v},expression:"validSubmission"}},[_c('Phase2Section1Register',{attrs:{"data":_vm.formFields}}),_c('Phase2Section2Sowing',{attrs:{"data":_vm.formFields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }